
import { Component, Vue, Prop } from "vue-property-decorator";

import ComplianceImage from "./assets/compliance.svg";
import EmployeeImage from "./assets/employee.svg";

const COMPLIANCE = "compliance";
const EMPLOYEE = "employee";

const IMAGES = [COMPLIANCE, EMPLOYEE];

@Component
export default class Home extends Vue {
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: String, default: "" }) readonly description!: string;
  @Prop({
    type: String,
    validator: (value: string) => IMAGES.includes(value),
    default: COMPLIANCE,
  })
  readonly image?: string;

  images = {
    [COMPLIANCE]: ComplianceImage,
    [EMPLOYEE]: EmployeeImage,
  };
}
